module.exports = __webpack_public_path__ + "img/collection-memoireRingsBestseller@2x.388dcc8.jpg";